import React from 'react';
import { TextInput, TextArea, Row, Button, BodyMediumText, } from 'playful-ui';

import { StyledForm } from './StyledForm';

export class WorkshopsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formSent: false,
      namePayee: '',
      nameAttendee: '',
      ageAttendee: '',
      emailPayee: '',
      message: '',
    };
  }

  handleSentForm = () => {
    const { namePayee, nameAttendee, ageAttendee, emailPayee, message } = this.state;
    if (namePayee && nameAttendee && ageAttendee && emailPayee && message) {
      this.setState({ formSent: true });
    }
  }

  handleChangeFormField = fieldName => e => this.setState({ [fieldName]: e.target.value });

  render() {
    const { id } = this.props;
    return (
      <StyledForm
        id={id}
        className="h-center workshops-form"
        method="POST"
        action="https://formspree.io/sales@stemi.education"
        autoComplete="off"
      >
        <Row className="h-center">
          <TextInput
            name="Ime naručitelja"
            className="input right-margin"
            onChange={this.handleChangeFormField('namePayee')}
            required
          >
            <label>Ime i prezime naručitelja</label>
          </TextInput>
          <TextInput
            name="Email naručitelja"
            className="input"
            onChange={this.handleChangeFormField('emailPayee')}
            required
          >
            <label>Email naručitelja</label>
          </TextInput>
        </Row>
        <Row className="h-center">
          <TextInput
            name="Ime polaznika"
            className="input right-margin"
            onChange={this.handleChangeFormField('nameAttendee')}
            required
          >
            <label>Ime polaznika</label>
          </TextInput>
          <TextInput
            name="Dob polaznika"
            className="input"
            onChange={this.handleChangeFormField('ageAttendee')}
            required
          >
            <label>Dob polaznika</label>
          </TextInput>
        </Row>
        <Row className="h-center">
          <TextArea name="Poruka" className="input" rows="6">
            <label>Poruka</label>
          </TextArea>
        </Row>
        <Button onClick={this.handleSentForm} type="submit">Pošalji prijavu</Button>
        {this.state.formSent &&
          <BodyMediumText>
            Vaša prijava je zaprimljena, javiti ćemo Vam se u najkraćem mogućem roku. 🤗
          </BodyMediumText>
        }
      </StyledForm>
    );
  }
}
